コピーした
(function () {
  function getProductSwiperEl() {
    var els = document.querySelectorAll('.swiper');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (!el.swiper) continue;
      if (el.closest('[class*="recommended"]')) continue;
      if (el.closest('[class*="announcement"]')) continue;
      return el;
    }
    return null;
  }

  function openMoreMediaIfNeeded(callback) {
    var btn = document.querySelector('[data-more-media]');
    if (!btn) { callback(); return; }
    var isOpen = btn.textContent.trim().toLowerCase().includes('less');
    if (isOpen) { callback(); return; }

    // スクロール位置を固定してMORE MEDIAを開く
    var scrollY = window.scrollY;
    document.body.style.overflow = 'hidden';
    btn.click();
    setTimeout(function () {
      window.scrollTo(0, scrollY);
      document.body.style.overflow = '';
      callback();
    }, 600);
  }

  function switchToMedia(targetMediaId) {
    // まずMORE MEDIAを開く
    openMoreMediaIfNeeded(function () {
      // 開いた後にSwiperとスライドが揃うまで待つ
      var attempts = 0;
      var interval = setInterval(function () {
        attempts++;
        var el = getProductSwiperEl();
        if (!el || !el.swiper) {
          if (attempts > 50) clearInterval(interval);
          return;
        }
        var slides = el.querySelectorAll('[data-media-id]');
        if (slides.length <= 1) {
          if (attempts > 50) clearInterval(interval);
          return;
        }
        var targetIndex = -1;
        slides.forEach(function (slide, i) {
          if (String(slide.dataset.mediaId) === String(targetMediaId)) targetIndex = i;
        });
        if (targetIndex !== -1) {
          clearInterval(interval);
          el.swiper.slideTo(targetIndex);
          console.log('slideTo:', targetIndex, 'mediaId:', targetMediaId);
        } else if (attempts > 50) {
          clearInterval(interval);
          console.log('timeout: mediaId not found');
        }
      }, 100);
    });
  }

  function getTargetMediaId() {
    var params = new URLSearchParams(window.location.search);
    var variantId = params.get('variant');
    if (!variantId) return null;
    var variantDataEl = document.querySelector('[data-variant-json]');
    if (!variantDataEl) return null;
    var variants;
    try { variants = JSON.parse(variantDataEl.textContent); }
    catch (e) { return null; }
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(variantId)) {
        return variants[i].featured_media ? variants[i].featured_media.id : null;
      }
    }
    return null;
  }

  var lastVariantId = null;
  var debounceTimer = null;

  function onVariantChange() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      var currentVariantId = new URLSearchParams(window.location.search).get('variant');
      if (!currentVariantId || currentVariantId === lastVariantId) return;
      lastVariantId = currentVariantId;
      var mediaId = getTargetMediaId();
      console.log('variant changed:', currentVariantId, 'mediaId:', mediaId);
      if (mediaId) switchToMedia(mediaId);
    }, 150);
  }

  var _pushState = history.pushState;
  history.pushState = function () {
    _pushState.apply(history, arguments);
    onVariantChange();
  };

  window.addEventListener('popstate', onVariantChange);

  new MutationObserver(function () {
    var currentVariantId = new URLSearchParams(window.location.search).get('variant');
    if (currentVariantId && currentVariantId !== lastVariantId) onVariantChange();
  }).observe(document.body, { childList: true, subtree: true });

})();